import './DataGridCell.scss';

import React, { ReactNode } from 'react';
import classNames from 'classnames';

import { IDataGridCellAppearance } from './models';

interface IProps extends IDataGridCellAppearance {
  type: 'gridcell' | 'columnheader';
  children: string | number | ReactNode;
  onClick?: () => void;
}

function DataGridCell({ type, children, onClick, flex, width, align = 'left' }: IProps) {
  const className = classNames(`modDataGridCell modDataGridCell--${align} modDataGridCell--${type}`, {
    'modDataGridCell--fixed-width': flex === null,
    'modDataGridCell--clickable': onClick,
  });

  return (
    <div
      className={className}
      role={type}
      onClick={onClick}
      style={{
        width,
        flex: flex !== null ? flex : undefined,
      }}>
      {children}
    </div>
  );
}

export default DataGridCell;
